import {
  FilingType,
  FinanceType,
  LoadingStatusType,
  PP30FormStatus,
  PP30FormTableViewStatusType,
  TransactionType,
  TypeComponentNoti,
} from "@/enums/enums";
import {
  ConvertToInsertPP30FormModel,
  ConvertToPP30FormDetailModel,
  ConvertToPP30TransactionTableByPeriodTax,
  SetHeaderPP30Form,
  SetHeaderPurchasePP30TransactionTable,
  SetHeaderSalesPP30TransactionTable,
  SetTapsPP30Form,
  SetTapsPP30TransactionTable,
  ValidateCreatePP30Transaction,
} from "@/helper/pp30Helper";
import { GetMessageExceptionCode, SetInputErrorByException } from "@/helper/shareHelper";
import { MerchantId } from "@/helper/userHelper";
import { i18n } from "@/i18n";
import router from "@/router";
import API from "@/service/Index";
import {
  ConvertToClosingEntryPP30ModelFromMongo,
  ConvertToInsertPP30TransactionModel,
  ConvertToPP30TransactionModel,
  ConvertToPP30TransactionTable,
  ConvertToPP30TransactionTableAdvanceSearch,
  ConvertToTablDetailPP30FormModel,
  ConvertToTaxInvoiceDetailListForTaxPP30,
  ConvertToUpdateIsFiledPP30,
  GetContactIdListForPreparePP30Transaction,
} from "@/service/pp30/pp30Facade";
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";
import store from "..";

@Module({ namespaced: true })
export default class PP30 extends VuexModule {
  public insertPP30TransactionLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public pp30Transaction: any | null = null;
  public pp30TransactionLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public updatePP30TransactionLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public tablePP30Transaction: any = [];
  public headerTablePP30Transaction: any = [];
  public tablePP30TransactionLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public tapsPP30TransactionTable: any = [];
  public voidPP30TransactionLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public tableCountPP30Transaction: any | null = null;
  public tableCountPP30TransactionLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public tablePP30FormList: any = null;
  public headerTablePP30Form: any = [];
  public tablePP30FormTaps: any = null;
  public tablePP30FormLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public pp30FormByPeriodTaxList: any = null;
  public pp30FormByPeriodListTaxListLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public pp30TransactionTableByPeriodTax: any = null;
  public pp30TransactionTableByPeriodTaxLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public pp30ByTaxPeriodOnchangeStatus = false;
  public pp30TransactionTableByPeriodTaxForAddNew: any = null;
  public pp30TransactionTableByPeriodTaxForAddNewLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public fetchDataPP30TransactionLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public numberOfFetchDataPP30 = 0;
  public taxCreditAmount: any = null;
  public taxCreditAmountLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public insertPP30FormLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public pp30FormDetail: any = null;
  public pp30FormDetailLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public voidPP30FormLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public updateIsFiledPP30LoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public isFiledPP30ModelFromMongoLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public isFiledPP30ModelFromMongoDetail: any = null;
  public updateIsClosingEntryPP30LoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public updateIsPaidPP30LoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public closingEntryPP30ModelFromMongo: any = null;
  public closingEntryPP30ModelFromMongoLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public createExpenseByIsClosingEntryPP30LoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public pp30FormByLastDateTimeLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public pp30FormByLastDateTimeList: any = null;
  public taxInvoiceDetailListForTaxPP30: any = null;
  public taxInvoiceDetailListForTaxPP30LoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public taxInvoiceDetailForUpdateTaxPP30: any = null;
  public taxInvoiceDetailForUpdateTaxPP30LoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public pp30TransactionForDetailLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public voidIsClosingEntryPP30ExpenseLoadingStatusType: LoadingStatusType = LoadingStatusType.None;
  public voidIsClosingEntryPP30JournalLoadingStatusType: LoadingStatusType = LoadingStatusType.None;

  get getInsertPP30TransactionLoadingStatus(): LoadingStatusType {
    return this.insertPP30TransactionLoadingStatus;
  }
  get getPP30Transaction(): any {
    return this.pp30Transaction;
  }
  get getPP30TransactionLoadingStatus(): LoadingStatusType {
    return this.pp30TransactionLoadingStatus;
  }
  get getUpdatePP30TransactionLoadingStatus(): LoadingStatusType {
    return this.updatePP30TransactionLoadingStatus;
  }
  get getTablePP30Transaction(): any {
    return this.tablePP30Transaction;
  }
  get getHeaderTablePP30Transaction(): any {
    return this.headerTablePP30Transaction;
  }
  get getTablePP30TransactionLoadingStatus(): LoadingStatusType {
    return this.tablePP30TransactionLoadingStatus;
  }
  get getTapsPP30TransactionTable(): any {
    return this.tapsPP30TransactionTable;
  }
  get getVoidPP30TransactionLoadingStatus(): LoadingStatusType {
    return this.voidPP30TransactionLoadingStatus;
  }
  get getTableCountPP30Transaction(): any {
    return this.tableCountPP30Transaction;
  }
  get getTableCountPP30TransactionLoadingStatus(): LoadingStatusType {
    return this.tableCountPP30TransactionLoadingStatus;
  }
  get getTablePP30FormList(): any {
    return this.tablePP30FormList;
  }
  get getHeaderTablePP30Form(): any {
    return this.headerTablePP30Form;
  }
  get getTablePP30FormTaps(): any {
    return this.tablePP30FormTaps;
  }
  get getTablePP30FormLoadingStatus(): LoadingStatusType {
    return this.tablePP30FormLoadingStatus;
  }
  get getPP30FormByPeriodTaxList(): any {
    return this.pp30FormByPeriodTaxList;
  }
  get getPP30FormByPeriodListTaxListLoadingStatus(): LoadingStatusType {
    return this.pp30FormByPeriodListTaxListLoadingStatus;
  }
  get getPP30TransactionTableByPeriodTaxLoadingStatus(): LoadingStatusType {
    return this.pp30TransactionTableByPeriodTaxLoadingStatus;
  }
  get getPP30TransactionTableByPeriodTax(): any {
    return this.pp30TransactionTableByPeriodTax;
  }
  get getPP30ByTaxPeriodOnchangeStatus(): any {
    return this.pp30ByTaxPeriodOnchangeStatus;
  }
  get getPP30TransactionTableByPeriodTaxForAddNewLoadingStatus(): LoadingStatusType {
    return this.pp30TransactionTableByPeriodTaxForAddNewLoadingStatus;
  }
  get getPP30TransactionTableByPeriodTaxForAddNew(): any {
    return this.pp30TransactionTableByPeriodTaxForAddNew;
  }
  get getFetchDataPP30TransactionLoadingStatus(): LoadingStatusType {
    return this.fetchDataPP30TransactionLoadingStatus;
  }
  get getNumberOfFetchDataPP30(): number {
    return this.numberOfFetchDataPP30;
  }
  get getTaxCreditAmount(): any {
    return this.taxCreditAmount;
  }
  get getTaxCreditAmountLoadingStatus(): LoadingStatusType {
    return this.taxCreditAmountLoadingStatus;
  }
  get getPP30FormDetail(): any {
    return this.pp30FormDetail;
  }
  get getPP30FormDetailLoadingStatus(): LoadingStatusType {
    return this.pp30FormDetailLoadingStatus;
  }
  get getUpdateIsFiledPP30LoadingStatus(): LoadingStatusType {
    return this.updateIsFiledPP30LoadingStatus;
  }
  get getIsFiledPP30ModelFromMongoLoadingStatus(): LoadingStatusType {
    return this.isFiledPP30ModelFromMongoLoadingStatus;
  }
  get getIsFiledPP30ModelFromMongoDetail(): any {
    return this.isFiledPP30ModelFromMongoDetail;
  }
  get getUpdateIsClosingEntryPP30LoadingStatus(): LoadingStatusType {
    return this.updateIsClosingEntryPP30LoadingStatus;
  }
  get getUpdateIsPaidPP30LoadingStatus(): LoadingStatusType {
    return this.updateIsPaidPP30LoadingStatus;
  }
  get getClosingEntryPP30ModelFromMongo(): any {
    return this.closingEntryPP30ModelFromMongo;
  }
  get getClosingEntryPP30ModelFromMongoLoadingStatus(): LoadingStatusType {
    return this.closingEntryPP30ModelFromMongoLoadingStatus;
  }
  get getCreateExpenseByIsClosingEntryPP30LoadingStatus(): LoadingStatusType {
    return this.createExpenseByIsClosingEntryPP30LoadingStatus;
  }
  get getPP30FormByLastDateTimeList(): any {
    return this.pp30FormByLastDateTimeList;
  }
  get getPP30FormByLastDateTimeLoadingStatus(): LoadingStatusType {
    return this.pp30FormByLastDateTimeLoadingStatus;
  }
  get getTaxInvoiceDetailListForTaxPP30(): any {
    return this.taxInvoiceDetailListForTaxPP30;
  }
  get getTaxInvoiceDetailListForTaxPP30LoadingStatus(): LoadingStatusType {
    return this.taxInvoiceDetailListForTaxPP30LoadingStatus;
  }
  get getTaxInvoiceDetailForUpdateTaxPP30(): any {
    return this.taxInvoiceDetailForUpdateTaxPP30;
  }
  get getTaxInvoiceDetailForUpdateTaxPP30LoadingStatus(): LoadingStatusType {
    return this.taxInvoiceDetailForUpdateTaxPP30LoadingStatus;
  }
  get getPP30TransactionForDetailLoadingStatus(): LoadingStatusType {
    return this.pp30TransactionForDetailLoadingStatus;
  }
  get getVoidIsClosingEntryPP30ExpenseLoadingStatusType(): LoadingStatusType {
    return this.voidIsClosingEntryPP30ExpenseLoadingStatusType;
  }
  get getVoidIsClosingEntryPP30JournalLoadingStatusType(): LoadingStatusType {
    return this.voidIsClosingEntryPP30JournalLoadingStatusType;
  }

  @Mutation
  public SetInsertPP30TransactionLoadingStatus(status: LoadingStatusType) {
    this.insertPP30TransactionLoadingStatus = status;
  }
  @Mutation
  public SetGetPP30Transaction(pp30Transaction: any) {
    this.pp30Transaction = pp30Transaction;
  }
  @Mutation
  public SetGetPP30TransactionLoadingStatus(status: LoadingStatusType) {
    this.pp30TransactionLoadingStatus = status;
  }
  @Mutation
  public SetUpdatePP30TransactionLoadingStatus(status: LoadingStatusType) {
    this.updatePP30TransactionLoadingStatus = status;
  }
  @Mutation
  public SetGetTablePP30Transaction(pp30Transaction: any) {
    this.tablePP30Transaction = pp30Transaction;
  }
  @Mutation
  public SetHeaderTablePP30Transaction(input: any) {
    if (input.financeType === FinanceType.InFlow) {
      this.headerTablePP30Transaction = SetHeaderSalesPP30TransactionTable();
    } else {
      this.headerTablePP30Transaction = SetHeaderPurchasePP30TransactionTable();
    }

    if (input.sorting !== null) {
      this.headerTablePP30Transaction.forEach((item: any) => {
        if (item.sortBy == input.sortBy) {
          item.sortingType = input.sortingType;
        } else {
          item.sortingType = null;
        }
      });
    }
  }
  @Mutation
  public SetGetTablePP30TransactionLoadingStatus(status: LoadingStatusType) {
    this.tablePP30TransactionLoadingStatus = status;
  }
  @Mutation
  public SetVoidPP30TransactionLoadingStatus(status: LoadingStatusType) {
    this.voidPP30TransactionLoadingStatus = status;
  }
  @Mutation
  public SetGetTableCountPP30TransactionLoadingStatus(status: LoadingStatusType) {
    this.tableCountPP30TransactionLoadingStatus = status;
  }
  @Mutation
  public SetGetTableCountPP30Transaction(table: any) {
    this.tableCountPP30Transaction = table.tableCountPP30Transaction;
    this.tapsPP30TransactionTable = SetTapsPP30TransactionTable(table.tableView, table.pp30TransactionCount);
  }
  @Mutation
  public SetTablePP30FormLoadingStatus(status: LoadingStatusType) {
    this.tablePP30FormLoadingStatus = status;
  }
  @Mutation
  public SetTablePP30Form(input: any) {
    this.tablePP30FormTaps = SetTapsPP30Form(input.tableView, input.data.countTable);
    this.tablePP30FormList = input.data.tableDetailPP30FormList;
  }
  @Mutation
  public SetTablePP30FormAdvanceSearch(input: any) {
    this.tablePP30FormTaps = SetTapsPP30Form(input.tableView, input.countTable);
    this.tablePP30FormList = input.tableDetailPP30FormList;
  }
  @Mutation
  public SetHeaderTablePP30Form(input: any) {
    this.headerTablePP30Form = SetHeaderPP30Form();

    if (input.sorting !== null) {
      this.headerTablePP30Form.forEach((item: any) => {
        if (item.sortBy == input.sortBy) {
          item.sortingType = input.sortingType;
        } else {
          item.sortingType = null;
        }
      });
    }
  }
  @Mutation
  public SetPP30FormByPeriodTaxList(pp30FormByPeriodTaxList: any) {
    this.pp30FormByPeriodTaxList = pp30FormByPeriodTaxList;
  }
  @Mutation
  public SetPP30FormByPeriodTaxListLoadingStatus(status: any) {
    this.pp30FormByPeriodListTaxListLoadingStatus = status;
  }

  @Mutation SetPP30TransactionTableByPeriodTaxLoadingStatus(status: any) {
    this.pp30TransactionTableByPeriodTaxLoadingStatus = status;
  }

  @Mutation SetPP30TransactionTableByPeriodTax(pp30TransactionTableByPeriodTax: any) {
    this.pp30TransactionTableByPeriodTax = pp30TransactionTableByPeriodTax;
  }
  @Mutation
  public SetPP30TransactionTableByPeriodTaxForAddNewLoadingStatus(status: LoadingStatusType) {
    this.pp30TransactionTableByPeriodTaxForAddNewLoadingStatus = status;
  }
  @Mutation
  public SetPP30TransactionTableByPeriodTaxForAddNew(pp30TransactionTableByPeriodTax: any) {
    this.pp30TransactionTableByPeriodTaxForAddNew = pp30TransactionTableByPeriodTax;
  }
  @Mutation
  public SetPP30ByTaxPeriodOnchangeStatus(status: boolean) {
    this.pp30ByTaxPeriodOnchangeStatus = status;
  }
  @Mutation
  public SetFetchDataPP30TransactionLoadingStatus(status: LoadingStatusType) {
    this.fetchDataPP30TransactionLoadingStatus = status;
  }
  @Mutation
  public SetNumberOfFetchDataPP30(number: number) {
    this.numberOfFetchDataPP30 = number;
  }
  @Mutation
  public SetTaxCreditAmount(pp30FormByPeriodTaxList: any) {
    this.taxCreditAmount = 0;
    pp30FormByPeriodTaxList.forEach((pp30FormByPeriodTax: any) => {
      if (pp30FormByPeriodTax.filingType == FilingType.Normal) {
        this.taxCreditAmount = pp30FormByPeriodTax.remainingTaxCreditAmount;
      }
    });
  }
  @Mutation
  public SetTaxCreditAmountListLoadingStatus(status: LoadingStatusType) {
    this.taxCreditAmountLoadingStatus = status;
  }
  @Mutation
  public SetInsertPP30FormLoadingStatusLoadingStatus(status: LoadingStatusType) {
    this.insertPP30FormLoadingStatus = status;
  }
  @Mutation
  public SetPP30FormDetai(pp30FormDetailModel: any) {
    this.pp30FormDetail = pp30FormDetailModel;
  }
  @Mutation
  public SetPP30FormDetailLoadingStatus(status: LoadingStatusType) {
    this.pp30FormDetailLoadingStatus = status;
  }
  @Mutation
  public SetPP30TransactionForDetailLoadingStatus(status: LoadingStatusType) {
    this.pp30TransactionForDetailLoadingStatus = status;
  }
  @Mutation
  public SetVoidPP30FormLoadingStatus(status: LoadingStatusType) {
    this.voidPP30FormLoadingStatus = status;
  }
  @Mutation
  public SetUpdateIsFiledPP30LoadingStatus(status: LoadingStatusType) {
    this.updateIsFiledPP30LoadingStatus = status;
  }
  @Mutation
  public SetIsFiledPP30ModelFromMongoLoadingStatus(status: LoadingStatusType) {
    this.isFiledPP30ModelFromMongoLoadingStatus = status;
  }
  @Mutation
  public SetIsFiledPP30ModelFromMongoDetail(IsFiledPP30Model: any) {
    this.isFiledPP30ModelFromMongoDetail = IsFiledPP30Model;
  }
  @Mutation
  public SetUpdateIsClosingEntryPP30LoadingStatus(status: LoadingStatusType) {
    this.updateIsClosingEntryPP30LoadingStatus = status;
  }

  @Mutation
  public SetUpdateIsPaidPP30LoadingStatus(status: LoadingStatusType) {
    this.updateIsPaidPP30LoadingStatus = status;
  }

  @Mutation
  public SetClosingEntryPP30ModelFromMongo(_closingEntryPP30ModelFromMongo: any) {
    this.closingEntryPP30ModelFromMongo = _closingEntryPP30ModelFromMongo;
  }

  @Mutation
  public SetClosingEntryPP30ModelFromMongoLoadingStatus(status: LoadingStatusType) {
    this.closingEntryPP30ModelFromMongoLoadingStatus = status;
  }

  @Mutation
  public SetCreateExpenseByIsClosingEntryPP30LoadingStatus(status: LoadingStatusType) {
    this.createExpenseByIsClosingEntryPP30LoadingStatus = status;
  }
  @Mutation
  public SetPP30FormByLastDateTimeLoadingStatus(status: LoadingStatusType) {
    this.pp30FormByLastDateTimeLoadingStatus = status;
  }

  @Mutation
  public SetPP30FormByLastDateTimeList(pp30FormByLastDateTimeInput: any): any {
    if (pp30FormByLastDateTimeInput && pp30FormByLastDateTimeInput.length > 0) {
      this.pp30FormByLastDateTimeList = pp30FormByLastDateTimeInput[0];
    } else {
      this.pp30FormByLastDateTimeList = null;
    }
  }

  @Mutation
  public SetTaxInvoiceDetailListForTaxPP30(taxInvoiceDetailListForTaxPP30: any) {
    this.taxInvoiceDetailListForTaxPP30 = taxInvoiceDetailListForTaxPP30;
  }

  @Mutation
  public SetTaxInvoiceDetailListForTaxPP30LoadingStatus(status: LoadingStatusType) {
    this.taxInvoiceDetailListForTaxPP30LoadingStatus = status;
  }

  @Mutation
  public SetVoidIsClosingEntryPP30ExpenseLoadingStatusType(status: LoadingStatusType) {
    this.voidIsClosingEntryPP30ExpenseLoadingStatusType = status;
  }

  @Mutation
  public SetVoidIsClosingEntryPP30JournalLoadingStatusType(status: LoadingStatusType) {
    this.voidIsClosingEntryPP30JournalLoadingStatusType = status;
  }

  @Mutation
  public SetTaxInvoiceDetailForUpdateTaxPP30(taxInvoiceDetailForUpdateTaxPP30: any) {
    this.taxInvoiceDetailForUpdateTaxPP30 = taxInvoiceDetailForUpdateTaxPP30;
  }

  @Mutation
  public SetTaxInvoiceDetailForUpdateTaxPP30LoadingStatus(status: LoadingStatusType) {
    this.taxInvoiceDetailForUpdateTaxPP30LoadingStatus = status;
  }

  @Action
  public DoInsertPP30Transaction(pp30TransactionTemplate: any) {
    const validated = ValidateCreatePP30Transaction(pp30TransactionTemplate);
    if (validated) {
      const pp30TransactionModel = ConvertToInsertPP30TransactionModel(pp30TransactionTemplate);
      if (this.insertPP30TransactionLoadingStatus !== LoadingStatusType.Loading) {
        this.context.commit("SetInsertPP30TransactionLoadingStatus", LoadingStatusType.Loading);
        API.PP30Service.InsertPP30Transaction(pp30TransactionModel).then((res) => {
          if (res.data.responseCode.IsSuccess()) {
            let linkName = "";
            let alertMessage = "";
            switch (pp30TransactionTemplate.financeType) {
              case FinanceType.InFlow:
                linkName = "salesTaxItemDetail";
                alertMessage = "Create_Sales_Tax_Item_Success";
                break;
              case FinanceType.OutFlow:
                linkName = "purchaseTaxItemDetail";
                alertMessage = "Create_Purchase_Tax_Item_Success";
                break;
            }
            router.push({
              name: linkName,
              query: { emi: MerchantId().PeakEncryption(), eti: btoa(res.data.data.id.toString()) },
            });
            store.dispatch(
              "Alert/SetAlertMessage",
              {
                alertMessage: i18n.t(alertMessage, { msg: res.data.data.taxInvoiceNumber }),
                typeMessage: TypeComponentNoti.success,
              },
              { root: true }
            );
            this.context.commit("SetInsertPP30TransactionLoadingStatus", LoadingStatusType.Success);
          } else {
            const alertMessage = GetMessageExceptionCode(res.data.exception);
            SetInputErrorByException(pp30TransactionTemplate, res.data.exception);
            this.context.dispatch(
              "Alert/SetAlertMessage",
              {
                alertMessage: alertMessage,
                typeMessage: TypeComponentNoti.error,
              },
              { root: true }
            );
            this.context.commit("SetInsertPP30TransactionLoadingStatus", LoadingStatusType.None);
          }
        });
      }
    } else {
      this.context.dispatch(
        "Alert/SetAlertMessage",
        {
          alertMessage: i18n.t("AlertNoti_Create_Input_Error"),
          typeMessage: TypeComponentNoti.error,
        },
        { root: true }
      );
    }
  }
  @Action
  public DoGetPP30Transaction(transactionId: number) {
    if (this.pp30TransactionLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetGetPP30TransactionLoadingStatus", LoadingStatusType.Loading);
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      API.PP30Service.GetPP30Transaction(transactionId).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          const pp30TransactionTemplate = ConvertToPP30TransactionModel(res.data.data);
          this.context.commit("SetGetPP30Transaction", pp30TransactionTemplate);
          this.context.commit("SetGetPP30TransactionLoadingStatus", LoadingStatusType.Success);
          this.context.dispatch("Loading/IsLoading", false, { root: true });
        }
      });
    }
  }
  @Action
  public DoUpdatePP30Transaction(pp30TransactionTemplate: any) {
    const pp30TransactionModel = ConvertToInsertPP30TransactionModel(pp30TransactionTemplate);
    if (this.updatePP30TransactionLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetUpdatePP30TransactionLoadingStatus", LoadingStatusType.Loading);
      API.PP30Service.UpdatePP30Transaction(pp30TransactionModel).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          store.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: i18n.t(
                pp30TransactionTemplate.financeType === FinanceType.InFlow
                  ? "Update_Sales_Tax_Item_Success"
                  : "Update_Purchase_Tax_Item_Success",
                { msg: res.data.data.taxInvoiceNumber }
              ),
              typeMessage: TypeComponentNoti.success,
            },
            { root: true }
          );
          this.context.commit("SetUpdatePP30TransactionLoadingStatus", LoadingStatusType.Success);
        } else {
          const alertMessage = GetMessageExceptionCode(res.data.exception);
          SetInputErrorByException(pp30TransactionTemplate, res.data.exception);
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: alertMessage,
              typeMessage: TypeComponentNoti.error,
            },
            { root: true }
          );
          this.context.commit("SetUpdatePP30TransactionLoadingStatus", LoadingStatusType.None);
        }
      });
    }
  }

  @Action
  public DoVoidPP30Transaction(input: any) {
    if (this.voidPP30TransactionLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetVoidPP30TransactionLoadingStatus", LoadingStatusType.Loading);
      API.PP30Service.VoidPP30Transaction(input.transactionId).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          let alertMessage = "";
          switch (input.financeType) {
            case FinanceType.InFlow:
              alertMessage = "Delete_Sales_Tax_Item_Success";
              break;
            case FinanceType.OutFlow:
              alertMessage = "Delete_Purchase_Tax_Item_Success";
              break;
          }
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: i18n.t(alertMessage, { msg: res.data.data.taxInvoiceNumber }),
              typeMessage: TypeComponentNoti.Success,
            },
            { root: true }
          );
        } else {
          const alertMessage = GetMessageExceptionCode(res.data.exception);
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: alertMessage,
              typeMessage: TypeComponentNoti.Error,
            },
            { root: true }
          );
        }
        this.context.commit("SetVoidPP30TransactionLoadingStatus", LoadingStatusType.Success);
      });
    }
  }

  @Action
  public DoGetTablePP30Transaction(input: any) {
    if (this.tablePP30TransactionLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetGetTablePP30TransactionLoadingStatus", LoadingStatusType.Loading);
      API.PP30Service.GetTablePP30Transaction(input).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          const tablePP30Transaction = ConvertToPP30TransactionTable(res.data.data);
          const headerTablePP30Transaction = {
            financeType: input.financeType,
            sortBy: input.transactionTableSortColumnType,
            sortingType: input.tableSortType,
          };
          this.context.commit("SetGetTablePP30Transaction", tablePP30Transaction);
          this.context.commit("SetHeaderTablePP30Transaction", headerTablePP30Transaction);
        }
        this.context.commit("SetGetTablePP30TransactionLoadingStatus", LoadingStatusType.Success);
      });
    }
  }
  @Action
  public DoGetTablePP30TransactionAdvanceSearchDefault(input: any) {
    if (this.tablePP30TransactionLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetGetTablePP30TransactionLoadingStatus", LoadingStatusType.Loading);
      API.PP30Service.GetTablePP30TransactionAdvanceSearchDefault(input).then(async (res) => {
        if (res.data.responseCode.IsSuccess()) {
          const contactIdList = GetContactIdListForPreparePP30Transaction(res.data.data);
          const headerTablePP30Transaction = {
            financeType: input.financeType,
            sortBy: input.transactionTableSortColumnType,
            sortingType: input.tableSortType,
          };
          if (contactIdList.length > 0) {
            await store.dispatch("Contact/DoGetContactByContactIdList", contactIdList, {
              root: true,
            });
          }
          const contactList = store.getters["Contact/getContactModelList"];
          const tablePP30Transaction = ConvertToPP30TransactionTableAdvanceSearch(res.data.data, contactList);
          this.context.commit("SetGetTablePP30Transaction", tablePP30Transaction);
          this.context.commit("SetHeaderTablePP30Transaction", headerTablePP30Transaction);
        }
        this.context.commit("SetGetTablePP30TransactionLoadingStatus", LoadingStatusType.Success);
      });
    }
  }
  @Action
  public DoGetTablePP30TransactionAdvanceSearch(input: any) {
    if (this.tablePP30TransactionLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetGetTablePP30TransactionLoadingStatus", LoadingStatusType.Loading);
      API.PP30Service.GetTablePP30TransactionAdvanceSearch(input).then(async (res) => {
        if (res.data.responseCode.IsSuccess()) {
          const contactIdList = GetContactIdListForPreparePP30Transaction(res.data.data);
          const headerTablePP30Transaction = {
            financeType: input.financeType,
            sortBy: input.transactionTableSortColumnType,
            sortingType: input.tableSortType,
          };
          if (contactIdList.length > 0) {
            await store.dispatch("Contact/DoGetContactByContactIdList", contactIdList, {
              root: true,
            });
          }
          const contactList = store.getters["Contact/getContactModelList"];
          const tablePP30Transaction = ConvertToPP30TransactionTableAdvanceSearch(res.data.data, contactList);
          this.context.commit("SetGetTablePP30Transaction", tablePP30Transaction);
          this.context.commit("SetHeaderTablePP30Transaction", headerTablePP30Transaction);
        }
        this.context.commit("SetGetTablePP30TransactionLoadingStatus", LoadingStatusType.Success);
      });
    }
  }
  @Action
  public DoGetTableCountPP30Transaction(input: any) {
    if (this.tableCountPP30TransactionLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetGetTableCountPP30TransactionLoadingStatus", LoadingStatusType.Loading);
      API.PP30Service.GetTableCountPP30Transaction(input).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          const tableCountPP30Transaction = {
            pp30TransactionCount: res.data.data,
            tableView: input.transactionTableViewStatusType,
          };
          this.context.commit("SetGetTableCountPP30Transaction", tableCountPP30Transaction);
        }
        this.context.commit("SetGetTableCountPP30TransactionLoadingStatus", LoadingStatusType.Success);
      });
    }
  }
  @Action
  public DoGetTableCountPP30TransactionAdvanceSearch(input: any) {
    if (this.tableCountPP30TransactionLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetGetTableCountPP30TransactionLoadingStatus", LoadingStatusType.Loading);
      API.PP30Service.GetTableCountPP30TransactionAdvanceSearch(input).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          const tableCountPP30Transaction = {
            pp30TransactionCount: res.data.data,
            tableView: input.transactionTableViewStatusType,
          };
          this.context.commit("SetGetTableCountPP30Transaction", tableCountPP30Transaction);
        }
        this.context.commit("SetGetTableCountPP30TransactionLoadingStatus", LoadingStatusType.Success);
      });
    }
  }
  @Action
  public DoGetTablePP30Form(input: any) {
    if (this.tablePP30FormLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetTablePP30FormLoadingStatus", LoadingStatusType.Loading);
      API.PP30Service.GetTablePP30Form(input).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          const tablePP30Form = {
            data: res.data.data,
            tableView: input.transactionTableViewStatusType,
          };
          const headerTablePP30Form = {
            sortBy: input.pp30FormTableSortColumnType,
            sortingType: input.tableSortType,
          };
          this.context.commit("SetTablePP30Form", tablePP30Form);
          this.context.commit("SetHeaderTablePP30Form", headerTablePP30Form);
        }
        this.context.commit("SetTablePP30FormLoadingStatus", LoadingStatusType.Success);
      });
    }
  }
  @Action
  public DoGetPP30FormTableAdvanceSearch(input: any) {
    if (this.tablePP30FormLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetTablePP30FormLoadingStatus", LoadingStatusType.Loading);
      API.PP30Service.GetPP30FormTableAdvanceSearch(input).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          const tablePP30Form = {
            tableDetailPP30FormList: ConvertToTablDetailPP30FormModel(res.data.data.tableDetailPP30FormList),
            countTable: res.data.data.countTable,
            tableView: input.transactionTableViewStatusType,
          };
          const headerTablePP30Form = {
            sortBy: input.pp30FormTableSortColumnType,
            sortingType: input.tableSortType,
          };
          this.context.commit("SetTablePP30FormAdvanceSearch", tablePP30Form);
          this.context.commit("SetHeaderTablePP30Form", headerTablePP30Form);
        }
        this.context.commit("SetTablePP30FormLoadingStatus", LoadingStatusType.Success);
      });
    }
  }
  @Action
  public DoGetPP30FormByPeriodTax(input: any) {
    if (this.pp30FormByPeriodListTaxListLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetPP30FormByPeriodTaxListLoadingStatus", LoadingStatusType.Loading);
      API.PP30Service.GetPP30FormByPeriodTax(input).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          this.context.commit("SetPP30FormByPeriodTaxList", res.data.data);
        }
        this.context.commit("SetPP30FormByPeriodTaxListLoadingStatus", LoadingStatusType.Success);
      });
    }
  }

  @Action
  public DoGetChangeTaxCreditAmount(input: any) {
    if (this.taxCreditAmountLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetTaxCreditAmountListLoadingStatus", LoadingStatusType.Loading);
      API.PP30Service.GetPP30FormByPeriodTax(input).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          this.context.commit("SetTaxCreditAmount", res.data.data);
        }
        this.context.commit("SetTaxCreditAmountListLoadingStatus", LoadingStatusType.Success);
      });
    }
  }

  @Action
  public DoGetPP30TransactionTableByPeriodTax(input: any) {
    if (this.pp30TransactionTableByPeriodTaxLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetPP30TransactionTableByPeriodTaxLoadingStatus", LoadingStatusType.Loading);
      API.PP30Service.GetPP30TransactionTableByPeriodTax(input).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          const pp30TransactionTableByPeriodTax = ConvertToPP30TransactionTableByPeriodTax(res.data.data);
          this.context.commit("SetPP30TransactionTableByPeriodTax", pp30TransactionTableByPeriodTax);
        }
        this.context.commit("SetPP30TransactionTableByPeriodTaxLoadingStatus", LoadingStatusType.Success);
      });
    }
  }

  @Action
  public DoGetPP30TransactionTableByPeriodTaxForAddNew(input: any) {
    if (this.pp30TransactionTableByPeriodTaxForAddNewLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetPP30TransactionTableByPeriodTaxForAddNewLoadingStatus", LoadingStatusType.Loading);
      API.PP30Service.GetPP30TransactionTableByPeriodTax(input).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          const pp30TransactionTableByPeriodTax = ConvertToPP30TransactionTableByPeriodTax(res.data.data);
          this.context.commit("SetPP30TransactionTableByPeriodTaxForAddNew", pp30TransactionTableByPeriodTax);
        }
        this.context.commit("SetPP30TransactionTableByPeriodTaxForAddNewLoadingStatus", LoadingStatusType.Success);
      });
    }
  }
  @Action
  public DoFetchDataPP30Transaction(input: any) {
    const prepareInput = {
      language: i18n.locale,
      financeType: input.financeType,
      fromDate: input.fromDate.ToDateJsonString(),
      toDate: input.toDate.ToDateJsonString(),
      isExceptItemFiled: input.isExceptItemFiled,
    };
    if (this.fetchDataPP30TransactionLoadingStatus !== LoadingStatusType.Loading) {
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      this.context.commit("SetFetchDataPP30TransactionLoadingStatus", LoadingStatusType.Loading);
      API.PP30Service.DoFetchDataPP30Transaction(prepareInput).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          if (res.data.data && res.data.data.length > 0) {
            this.context.commit("SetNumberOfFetchDataPP30", res.data.data.length);
          } else {
            this.context.commit("SetNumberOfFetchDataPP30", 0);
            this.context.dispatch(
              "Alert/SetAlertMessage",
              {
                alertMessage: i18n.t("Fetch_Data_Not_Found", {
                  name: i18n.t(
                    input.financeType === FinanceType.InFlow ? "Sales_Tax_Lowercase" : "Purchase_Tax_Lowercase"
                  ),
                }),
                typeMessage: TypeComponentNoti.error,
              },
              { root: true }
            );
          }
          this.context.commit("SetFetchDataPP30TransactionLoadingStatus", LoadingStatusType.Success);
          this.context.dispatch("Loading/IsLoading", false, { root: true });
        } else {
          const alertMessage = GetMessageExceptionCode(res.data.exception);
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: alertMessage,
              typeMessage: TypeComponentNoti.error,
            },
            { root: true }
          );
          this.context.commit("SetFetchDataPP30TransactionLoadingStatus", LoadingStatusType.Fail);
          this.context.dispatch("Loading/IsLoading", false, { root: true });
        }
      });
    }
  }

  @Action
  public DoInsertPP30Form(pp30FormCreateTemplate: any) {
    if (this.insertPP30FormLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetInsertPP30FormLoadingStatusLoadingStatus", LoadingStatusType.Loading);
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      const insertPP30FormModel = ConvertToInsertPP30FormModel(pp30FormCreateTemplate);
      API.PP30Service.InsertPP30Form(insertPP30FormModel).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          if (pp30FormCreateTemplate.status < PP30FormStatus.AwaitFiling) {
            router.push({
              name: "pp30form",
              query: { emi: MerchantId().PeakEncryption() },
            });
          } else {
            router.push({
              name: "pp30Detail",
              query: { emi: MerchantId().PeakEncryption(), epi: btoa(res.data.data.id.toString()) },
            });
          }
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: i18n.t("Created_PP30_Success", { msg: res.data.data.formNumber }),
              typeMessage: TypeComponentNoti.success,
            },
            { root: true }
          );
        } else {
          const alertMessage = GetMessageExceptionCode(res.data.exception);
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: alertMessage,
              typeMessage: TypeComponentNoti.error,
            },
            { root: true }
          );
        }
        this.context.dispatch("Loading/IsLoading", false, { root: true });
        this.context.commit("SetInsertPP30FormLoadingStatusLoadingStatus", LoadingStatusType.Success);
      });
    }
  }

  @Action
  public GetPP30FormById(pp30FormId: any) {
    if (this.pp30FormDetailLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetPP30FormDetailLoadingStatus", LoadingStatusType.Loading);
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      API.PP30Service.GetPP30FormById(pp30FormId).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          API.PP30Service.GetPP30TransactionTableByPP30Id(pp30FormId).then((resPP30Transaction) => {
            if (res.data.responseCode.IsSuccess()) {
              const pp30FormDetailModel = ConvertToPP30FormDetailModel(res.data.data, resPP30Transaction.data.data);
              this.context.commit("SetPP30FormDetai", pp30FormDetailModel);
            }
            this.context.dispatch("Loading/IsLoading", false, { root: true });
            this.context.commit("SetPP30FormDetailLoadingStatus", LoadingStatusType.Success);
          });
        }
      });
    }
  }

  @Action
  public DoUpdatePP30Form(pp30FormCreateTemplate: any) {
    if (this.insertPP30FormLoadingStatus !== LoadingStatusType.Loading) {
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      this.context.commit("SetInsertPP30FormLoadingStatusLoadingStatus", LoadingStatusType.Loading);
      const insertPP30FormModel = ConvertToInsertPP30FormModel(pp30FormCreateTemplate);
      API.PP30Service.UpdatePP30Form(insertPP30FormModel).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          if (pp30FormCreateTemplate.status < PP30FormStatus.AwaitFiling) {
            router.push({
              name: "pp30form",
              query: { emi: MerchantId().PeakEncryption() },
            });
          } else {
            router.push({
              name: "pp30Detail",
              query: { emi: MerchantId().PeakEncryption(), epi: btoa(res.data.data.id.toString()) },
            });
          }
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: i18n.t("Updated_PP30_Success", { msg: res.data.data.formNumber }),
              typeMessage: TypeComponentNoti.success,
            },
            { root: true }
          );
        } else {
          const alertMessage = GetMessageExceptionCode(res.data.exception);
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: alertMessage,
              typeMessage: TypeComponentNoti.error,
            },
            { root: true }
          );
        }
        this.context.dispatch("Loading/IsLoading", false, { root: true });
        this.context.commit("SetInsertPP30FormLoadingStatusLoadingStatus", LoadingStatusType.Success);
      });
    }
  }

  @Action
  public DoVoidPP30Form(pp30Form: any) {
    if (this.voidPP30FormLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetVoidPP30FormLoadingStatus", LoadingStatusType.Loading);
      API.PP30Service.VoidPP30Form(pp30Form.id).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          router.push({
            name: "pp30form",
            query: { emi: MerchantId().PeakEncryption(), stid: PP30FormTableViewStatusType.Voided.toString() },
          });
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: i18n.t("Voided_PP30_Success", { msg: res.data.data.formNumber }),
              typeMessage: TypeComponentNoti.success,
            },
            { root: true }
          );
        } else {
          const alertMessage = GetMessageExceptionCode(res.data.exception);
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: alertMessage,
              typeMessage: TypeComponentNoti.error,
            },
            { root: true }
          );
        }
        this.context.commit("SetVoidPP30FormLoadingStatus", LoadingStatusType.Success);
      });
    }
  }

  @Action
  public DoGetIsFiledPP30(input: any) {
    if (this.isFiledPP30ModelFromMongoLoadingStatus !== LoadingStatusType.Loading) {
      const data = {
        pp30Id: input.pp30Id,
      };
      this.context.commit("SetIsFiledPP30ModelFromMongoLoadingStatus", LoadingStatusType.Loading);
      API.PP30Service.GetIsFiledPP30Model(data).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          this.context.commit("SetIsFiledPP30ModelFromMongoDetail", res.data.data);
          this.context.commit("SetIsFiledPP30ModelFromMongoLoadingStatus", LoadingStatusType.Success);
        }
      });
    }
  }

  @Action
  public DoUpdateIsFiledPP30ByPrintForm(input: any) {
    if (this.updateIsFiledPP30LoadingStatus !== LoadingStatusType.Loading) {
      const url = `${
        process.env.VUE_APP_PeakDocument
      }pp30?emi=${MerchantId().PeakEncryption()}&eti=${input.pp30Id.PeakEncryption()}&etti=${TransactionType.PP30.PeakEncryption()}`;

      window.open(url);

      const pp30UpdateIsFiledOption = ConvertToUpdateIsFiledPP30(input, url);
      this.context.commit("SetUpdateIsFiledPP30LoadingStatus", LoadingStatusType.Loading);
      API.PP30Service.UpdateIsFiledByPP30Id(pp30UpdateIsFiledOption).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: i18n.t("Filing_Tax_Form_Success", { msg: input.formNumber }),
              typeMessage: TypeComponentNoti.Success,
            },
            { root: true }
          );
          this.context.commit("SetPP30FormDetailLoadingStatus", LoadingStatusType.None);
          this.context.commit("SetIsFiledPP30ModelFromMongoLoadingStatus", LoadingStatusType.None);
        } else {
          const alertMessage = GetMessageExceptionCode(res.data.exception);
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: alertMessage,
              typeMessage: TypeComponentNoti.Error,
            },
            { root: true }
          );
        }
        this.context.commit("SetUpdateIsFiledPP30LoadingStatus", LoadingStatusType.Success);
      });
    }
  }

  @Action
  public DoVoidIsFiledPP30(input: any) {
    if (this.updateIsFiledPP30LoadingStatus !== LoadingStatusType.Loading) {
      const pp30UpdateIsFiledOption = ConvertToUpdateIsFiledPP30(input, "");
      this.context.commit("SetUpdateIsFiledPP30LoadingStatus", LoadingStatusType.Loading);
      API.PP30Service.UpdateIsFiledByPP30Id(pp30UpdateIsFiledOption).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: i18n.t("Cancel_Filed_Success", { msg: input.formNumber }),
              typeMessage: TypeComponentNoti.Success,
            },
            { root: true }
          );
          this.context.commit("SetPP30FormDetailLoadingStatus", LoadingStatusType.None);
          this.context.commit("SetIsFiledPP30ModelFromMongoLoadingStatus", LoadingStatusType.None);
        } else {
          const alertMessage = GetMessageExceptionCode(res.data.exception);
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: alertMessage,
              typeMessage: TypeComponentNoti.Error,
            },
            { root: true }
          );
        }
        this.context.commit("SetUpdateIsFiledPP30LoadingStatus", LoadingStatusType.Success);
      });
    }
  }

  @Action
  public DoUpdateIsPaidPP30(input: any) {
    if (this.updateIsPaidPP30LoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetUpdateIsPaidPP30LoadingStatus", LoadingStatusType.Loading);
      API.PP30Service.UpdateIsPaidByPP30Id(input).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: input.isPaid
                ? i18n.t("Payment_Tax_Success", { msg: input.formNumber })
                : i18n.t("Cancel_Payment_Tax_Success", { msg: input.formNumber }),
              typeMessage: TypeComponentNoti.Success,
            },
            { root: true }
          );

          this.context.commit("SetPP30FormDetailLoadingStatus", LoadingStatusType.None);
          this.context.commit("SetIsFiledPP30ModelFromMongoLoadingStatus", LoadingStatusType.None);
        } else {
          const alertMessage = GetMessageExceptionCode(res.data.exception);
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: alertMessage,
              typeMessage: TypeComponentNoti.Error,
            },
            { root: true }
          );
        }

        this.context.commit("SetUpdateIsPaidPP30LoadingStatus", LoadingStatusType.Success);
      });
    }
  }

  @Action
  public DoUpdateIsClosingEntryPP30(input: any) {
    if (this.updateIsClosingEntryPP30LoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetUpdateIsClosingEntryPP30LoadingStatus", LoadingStatusType.Loading);
      API.PP30Service.UpdateIsClosingEntryPP30(input).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: i18n.t("Record_Closing_Tax_Success", { msg: input.formNumber }),
              typeMessage: TypeComponentNoti.Success,
            },
            { root: true }
          );
          this.context.commit("SetPP30FormDetailLoadingStatus", LoadingStatusType.None);
          this.context.commit("SetClosingEntryPP30ModelFromMongoLoadingStatus", LoadingStatusType.None);
        } else {
          const alertMessage = GetMessageExceptionCode(res.data.exception);
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: alertMessage,
              typeMessage: TypeComponentNoti.Error,
            },
            { root: true }
          );
        }
        this.context.commit("SetUpdateIsClosingEntryPP30LoadingStatus", LoadingStatusType.Success);
      });
    }
  }

  @Action
  public DoCreateExpenseByIsClosingEntryPP30(input: any) {
    if (this.createExpenseByIsClosingEntryPP30LoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetCreateExpenseByIsClosingEntryPP30LoadingStatus", LoadingStatusType.Loading);
      API.PP30Service.CreateExpenseByIsClosingEntryPP30(input).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: i18n.t("Record_Payment_Success", { msg: input.formNumber }),
              typeMessage: TypeComponentNoti.Success,
            },
            { root: true }
          );
          this.context.commit("SetClosingEntryPP30ModelFromMongoLoadingStatus", LoadingStatusType.None);
        } else {
          const alertMessage = GetMessageExceptionCode(res.data.exception);
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: alertMessage,
              typeMessage: TypeComponentNoti.Error,
            },
            { root: true }
          );
        }
        this.context.commit("SetCreateExpenseByIsClosingEntryPP30LoadingStatus", LoadingStatusType.Success);
      });
    }
  }

  @Action
  public DoGetClosingEntryPP30ModelFromMongo(input: any) {
    if (this.closingEntryPP30ModelFromMongoLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetClosingEntryPP30ModelFromMongoLoadingStatus", LoadingStatusType.Loading);
      API.PP30Service.GetClosingEntryPP30ModelFromMongo(input).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          const closingEntryPP30ModelFromMongo = ConvertToClosingEntryPP30ModelFromMongo(res.data.data);
          this.context.commit("SetClosingEntryPP30ModelFromMongo", closingEntryPP30ModelFromMongo);
        }
        this.context.commit("SetClosingEntryPP30ModelFromMongoLoadingStatus", LoadingStatusType.Success);
      });
    }
  }

  @Action
  public DoGetPeakTaxInvoiceList(input: any) {
    if (this.taxInvoiceDetailListForTaxPP30LoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetTaxInvoiceDetailListForTaxPP30LoadingStatus", LoadingStatusType.Loading);
      API.PP30Service.GetPeakTaxInvoiceList(input).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          const taxInvoiceList = ConvertToTaxInvoiceDetailListForTaxPP30(res.data.data);
          this.context.commit("SetTaxInvoiceDetailListForTaxPP30", taxInvoiceList);
        }
        this.context.commit("SetTaxInvoiceDetailListForTaxPP30LoadingStatus", LoadingStatusType.Success);
      });
    }
  }

  @Action
  public DoGetPeakTaxInvoiceListForUpdatePP30Transaction(input: any) {
    if (this.taxInvoiceDetailForUpdateTaxPP30LoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetTaxInvoiceDetailForUpdateTaxPP30LoadingStatus", LoadingStatusType.Loading);
      API.PP30Service.GetPeakTaxInvoiceList(input.idList).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          const taxInvoiceList = ConvertToTaxInvoiceDetailListForTaxPP30(res.data.data);
          this.context.commit("SetTaxInvoiceDetailForUpdateTaxPP30", taxInvoiceList[0]);
          if (this.pp30TransactionLoadingStatus !== LoadingStatusType.Loading) {
            this.context.dispatch("Loading/IsLoading", true, { root: true });
            API.PP30Service.GetPP30Transaction(input.transactionId).then((res) => {
              if (res.data.responseCode.IsSuccess()) {
                const pp30TransactionTemplate = ConvertToPP30TransactionModel(res.data.data);
                this.context.commit("SetGetPP30Transaction", pp30TransactionTemplate);
              }
              this.context.commit("SetTaxInvoiceDetailForUpdateTaxPP30LoadingStatus", LoadingStatusType.Success);
              this.context.dispatch("Loading/IsLoading", false, { root: true });
            });
          }
        }
      });
    }
  }

  @Action
  public DoGetPP30FormByLastDateTime() {
    if (this.pp30FormByLastDateTimeLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetPP30FormByLastDateTimeLoadingStatus", LoadingStatusType.Loading);
      API.PP30Service.GetPP30FormByLastDateTime().then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          this.context.commit("SetPP30FormByLastDateTimeList", res.data.data);
        }
        this.context.commit("SetPP30FormByLastDateTimeLoadingStatus", LoadingStatusType.Success);
      });
    }
  }

  @Action
  public DoVoidIsClosingEntryPP30Journal(input: any) {
    if (this.voidIsClosingEntryPP30JournalLoadingStatusType !== LoadingStatusType.Loading) {
      this.context.commit("SetVoidIsClosingEntryPP30JournalLoadingStatusType", LoadingStatusType.Loading);
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      API.PP30Service.VoidIsClosingEntryPP30Journal(input.data).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: i18n.t("Void_Record_Account_Success", { number: input.journalNumber }),
              typeMessage: TypeComponentNoti.Success,
            },
            { root: true }
          );
          this.context.commit("SetPP30FormDetailLoadingStatus", LoadingStatusType.None);
          this.context.commit("SetClosingEntryPP30ModelFromMongoLoadingStatus", LoadingStatusType.None);
        } else {
          const alertMessage = GetMessageExceptionCode(res.data.exception);
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: alertMessage,
              typeMessage: TypeComponentNoti.Error,
            },
            { root: true }
          );
        }
        this.context.commit("SetVoidIsClosingEntryPP30JournalLoadingStatusType", LoadingStatusType.Success);
        this.context.dispatch("Loading/IsLoading", false, { root: true });
      });
    }
  }
  @Action
  public DoVoidIsClosingEntryPP30Expense(input: any) {
    if (this.voidIsClosingEntryPP30ExpenseLoadingStatusType !== LoadingStatusType.Loading) {
      this.context.commit("SetVoidIsClosingEntryPP30ExpenseLoadingStatusType", LoadingStatusType.Loading);
      API.PP30Service.VoidIsClosingEntryPP30Expense(input.data).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: i18n.t("Void_Record_Payment_Tax_Success", { number: input.expenseNumber }),
              typeMessage: TypeComponentNoti.Success,
            },
            { root: true }
          );
          this.context.commit("SetClosingEntryPP30ModelFromMongoLoadingStatus", LoadingStatusType.None);
        } else {
          const alertMessage = GetMessageExceptionCode(res.data.exception);
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: alertMessage,
              typeMessage: TypeComponentNoti.Error,
            },
            { root: true }
          );
        }
        this.context.commit("SetVoidIsClosingEntryPP30ExpenseLoadingStatusType", LoadingStatusType.Success);
      });
    }
  }
}
